import apiClient from '../../Services/ApiClient';

// @ts-ignore
export const loadIdentificationDocumentTypes = async () => {
	const { data: result } = await apiClient.get(
		'/terms/identification_document_type/items',
	);
	const documentTypes = {};
	for (const documentType of result.data) {
		documentTypes[documentType.id] = documentType.name;
	}
	return documentTypes;
};

export const parseUserMeta = user => {
	const metaItems = {};
	if (user && user.meta) {
		for (const metaItem of user.meta) {
			metaItems[metaItem.key] = metaItem.value;
		}
	}

	return metaItems;
};
